module.exports = __webpack_public_path__ + "static/media/receta-06.7d5435a3.png";